import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            剧集周边
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            幕后花絮、精彩剧评、深度解析，全方位了解你爱的剧
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300/40 transition-all cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 to-transparent"></div>
                <div className="absolute bottom-2 right-2 flex items-center gap-1.5 px-2 py-1 rounded bg-background-950/70 text-background-100 text-xs">
                  <i className="ri-play-circle-line text-xs"></i>
                  <span>{item.duration}</span>
                </div>
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded bg-background-50/90 text-xs font-medium text-foreground-700 whitespace-nowrap">
                  {item.type}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-xs md:text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}